import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const NewsLazy = loadable(() => import(/* webpackChunkName: "News" */ './NewsSuspense'));

export const NewsAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <NewsLazy />
    </DelayedSuspense>
);
